module.exports = __webpack_public_path__ + "ff1788458548da0479714cba0df88410.png";